/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { calendarConnectionIndex } from '../../axios/calendarConnectionIndex'
import type { CalendarConnectionIndexError, CalendarConnectionIndexResponse } from '../../types/CalendarConnectionIndex'

export const calendarConnectionIndexQueryKey = () => [{ url: '/calendar-integrations/connections' }] as const

export type CalendarConnectionIndexQueryKey = ReturnType<typeof calendarConnectionIndexQueryKey>

/** @see backend/nexus/modules/CalendarIntegrations/Http/Controllers/CalendarConnectionController.php CalendarConnectionController::index */
export function calendarConnectionIndexQueryOptions(config?: AxiosRequestConfig) {
	return queryOptions<
		CalendarConnectionIndexResponse,
		AxiosError<CalendarConnectionIndexError>,
		CalendarConnectionIndexResponse,
		CalendarConnectionIndexQueryKey
	>({
		queryKey: calendarConnectionIndexQueryKey(),
		queryFn: ({ signal }) => calendarConnectionIndex({ signal, ...config }).then(res => res.data),
	})
}

/** @see backend/nexus/modules/CalendarIntegrations/Http/Controllers/CalendarConnectionController.php CalendarConnectionController::index */
export function useCalendarConnectionIndex<TSelectData = CalendarConnectionIndexResponse>(
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					CalendarConnectionIndexResponse,
					AxiosError<CalendarConnectionIndexError>,
					TSelectData,
					CalendarConnectionIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<CalendarConnectionIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...calendarConnectionIndexQueryOptions(),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/CalendarIntegrations/Http/Controllers/CalendarConnectionController.php CalendarConnectionController::index */
export function useCalendarConnectionIndexSuspense<TSelectData = CalendarConnectionIndexResponse>(
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					CalendarConnectionIndexResponse,
					AxiosError<CalendarConnectionIndexError>,
					TSelectData,
					CalendarConnectionIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<CalendarConnectionIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...calendarConnectionIndexQueryOptions(),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
